import { httpClient } from '../http/httpClient'

export interface Adicional {
  convenioDadosId: number
  nome: string
  tipo: number
  ordem: number
  formato: string
}

export interface Valor {
  valor: number
}

export interface DiaRecebimento {
  id: number
  nome: string
}

export interface Offer {
  nome: string
  produtoId: number
  convenio: string
  convenioId: number
  tabelaJurosId: number
  adicionais: Adicional[]
  maxValor: number
  valores: Valor[]
  diaRecebimento: DiaRecebimento[]
  commission: number
  bonus: number
  vencimento: string
}

export interface Proposta {
  cpf: string
  nome: string
  valorRendaPresumida: number
  propostaId: string
}

export interface GetOffersProposalResponse {
  offers: Offer[]
  proposta: Proposta
}

export async function getOffersProposal(propostaId: string) {
  const { data } = await httpClient
    .get<GetOffersProposalResponse>(`/crefaz/${propostaId}/offers`)
    .catch((error) => {
      throw error.response?.data || error
    })
  return data
}
